<div class="sub-header">
  <ng-content />
</div>
